export interface TokenValidity {
  readonly token: string;
  readonly type: string;
}

export enum TokenValidityType {
  PASSWORD_RESET = 'PASSWORD_RESET',
  VERIFY = 'VERIFY',
}
